import React from "react";
import { AGENT } from "@/lib/site";

export default function WhatsAppButton() {
  const url = `https://wa.me/${AGENT.whatsapp}?text=${encodeURIComponent(
    "Pozdravljeni, zanima me vaše svetovanje."
  )}`;
  return (
    <a
      href={url}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-floating"
      aria-label="Kontakt preko WhatsAppa"
      className="vp-pulse fixed bottom-6 right-6 z-50 inline-flex h-14 w-14 items-center justify-center rounded-full shadow-lg hover:scale-105 transition-transform"
      style={{ background: "#25D366" }}
    >
      <svg viewBox="0 0 24 24" width="26" height="26" fill="white" aria-hidden>
        <path d="M19.05 4.91A9.82 9.82 0 0 0 12.04 2a9.83 9.83 0 0 0-8.49 14.74L2 22l5.42-1.42a9.84 9.84 0 0 0 4.62 1.17h.01c5.42 0 9.83-4.41 9.83-9.83 0-2.62-1.02-5.09-2.83-6.91zm-7.01 15.13h-.01a8.18 8.18 0 0 1-4.17-1.14l-.3-.18-3.22.85.86-3.13-.2-.32a8.18 8.18 0 1 1 7.04 3.92zm4.49-6.13c-.25-.12-1.46-.72-1.68-.8-.22-.08-.39-.12-.55.12-.16.25-.63.8-.78.96-.14.16-.29.18-.54.06-.25-.12-1.05-.39-2-1.23-.74-.66-1.24-1.48-1.39-1.73-.14-.25-.02-.39.11-.51.11-.11.25-.29.37-.43.12-.14.16-.25.25-.41.08-.16.04-.31-.02-.43-.06-.12-.55-1.32-.75-1.81-.2-.48-.4-.41-.55-.42h-.47c-.16 0-.43.06-.65.31s-.86.84-.86 2.05.88 2.38 1 2.54c.12.16 1.74 2.66 4.21 3.73 1.47.64 2.04.69 2.78.58.45-.07 1.46-.6 1.67-1.18.21-.58.21-1.08.14-1.18-.06-.1-.22-.16-.47-.28z" />
      </svg>
    </a>
  );
}
